import agent from '@/api/agent';

export default class ImageRow {
  static get toolbox() {
    return {
      title: 'Галерия от изображения',
      icon: '<svg width="18" height="18"><path d="M3 3h12v12H3z"/></svg>'
    };
  }

  constructor({ data, api }) {
    this.api = api;
    this.data = {
      images: Array.isArray(data?.images) ? data.images : []
    };
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('image-row-wrapper');

    this.renderImages();
    this.renderAddButton();

    return this.wrapper;
  }

  renderImages() {
    const imagesContainer = document.createElement('div');
    imagesContainer.className = 'image-row-container';

    if (!Array.isArray(this.data.images)) {
      this.data.images = [];
    }

    this.data.images.forEach((image, index) => {
      const imgWrapper = document.createElement('div');
      imgWrapper.className = 'image-row-item';

      const img = document.createElement('img');
      img.src = image.url;
      img.alt = image.caption || '';
      img.title = image.caption || '';
      img.className = 'image-row-preview';

      const captionInput = document.createElement('input');
      const linkInput = document.createElement('input');
      linkInput.type = 'url';
      linkInput.placeholder = 'Линк към изображението';
      linkInput.value = image.link || '';
      linkInput.className = 'image-row-link';
      linkInput.addEventListener('input', () => {
        this.data.images[index].link = linkInput.value;
      });

      captionInput.type = 'text';
      captionInput.placeholder = 'Описание';
      captionInput.value = image.caption || '';
      captionInput.className = 'image-row-caption';
      captionInput.addEventListener('input', () => {
        this.data.images[index].caption = captionInput.value;
      });

      const removeBtn = document.createElement('button');
      removeBtn.textContent = '✖';
      removeBtn.className = 'image-row-remove';
      removeBtn.addEventListener('click', () => {
        this.data.images.splice(index, 1);
        this.wrapper.innerHTML = '';
        this.renderImages();
        this.renderAddButton();
      });

      imgWrapper.appendChild(img);
      imgWrapper.appendChild(captionInput);
      imgWrapper.appendChild(linkInput);

      imgWrapper.appendChild(removeBtn);

      imagesContainer.appendChild(imgWrapper);
    });

    this.wrapper.appendChild(imagesContainer);
  }

  renderAddButton() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = true;
    input.style.display = 'none';

    const button = document.createElement('button');
    button.textContent = 'Добави изображения';
    button.className = 'image-row-add';
    button.type = 'button';
    button.addEventListener('click', () => input.click());

    input.addEventListener('change', async (event) => {
      const files = Array.from(event.target.files);

      for (const file of files) {
        const formData = new FormData();
        formData.append('image/jpeg', file, file.name);

        // Тук заменяш с твоя агент за качване на снимки:
        const response = await agent.Images.uploadImage(formData);
        if (response.status === 200) {
          const imageUrl = response.data.url.replace('resources/', '');

          this.data.images.push({
            url: imageUrl,
            caption: ''
          });
        }
      }

      this.wrapper.innerHTML = '';
      this.renderImages();
      this.renderAddButton();
    });

    this.wrapper.appendChild(input);
    this.wrapper.appendChild(button);
  }

  save() {
    return this.data;
  }
}
